import { UIRouter } from '@uirouter/core';

import { registrationLinkErrorHook } from '../registration_link/registration-link-error.hook';

export function authenticationRouterConfigFn (router: UIRouter) {
	const transitionService = router.transitionService;

	registrationLinkErrorHook(transitionService);
}
